export const selectorIsShareCanvasModalOpen = (state) => state.canvasSharing.isModalOpen;
export const selectorIsPreEnabled = (state) => state.canvasSharing.preEnabled;
